import React from "react";
import { Box, Stack, Typography, Chip, Skeleton } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import GroupIcon from "@mui/icons-material/Group";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

/**
 * Subheader del dashboard con título, fecha fuente y quick stats inline.
 */
export default function DashboardSubheader({ summary, location, loading }) {
  if (loading) {
    return (
      <Stack direction="row" alignItems="center" spacing={2}>
        <Skeleton variant="text" width={200} height={28} />
        <Skeleton variant="rounded" width={120} height={24} />
        <Skeleton variant="rounded" width={100} height={24} />
      </Stack>
    );
  }

  const sourceDate = summary?.meta?.sourceDate;
  const kpis = summary?.kpis;
  const pcpCount = summary?.pcps?.length || 0;

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      spacing={1.5}
      sx={{ flexWrap: "wrap" }}
    >
      {/* Lado izquierdo: título + dirección */}
      <Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
          {location?.address || ""}
        </Typography>
      </Box>

      {/* Lado derecho: quick stats */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ flexWrap: "wrap" }}>
        {sourceDate && (
          <Chip
            icon={<CalendarTodayIcon sx={{ fontSize: 14 }} />}
            label={`Data: ${sourceDate}`}
            size="small"
            variant="outlined"
            sx={{ fontSize: "0.7rem", height: 24 }}
          />
        )}
        {kpis && (
          <Chip
            icon={<GroupIcon sx={{ fontSize: 14 }} />}
            label={`${kpis.assignedPatients?.toLocaleString()} patients`}
            size="small"
            sx={{
              fontSize: "0.7rem",
              height: 24,
              bgcolor: "#EFF6FF",
              color: "#2563EB",
              fontWeight: 600,
            }}
          />
        )}
        {pcpCount > 0 && (
          <Chip
            icon={<MedicalServicesIcon sx={{ fontSize: 14 }} />}
            label={`${pcpCount} providers`}
            size="small"
            sx={{
              fontSize: "0.7rem",
              height: 24,
              bgcolor: "#F0FDF4",
              color: "#166534",
              fontWeight: 600,
            }}
          />
        )}
      </Stack>
    </Stack>
  );
}
